/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import Button from 'elements/Button'
import Icon from 'elements/Icon'
import * as styles from './ButtonWithIcon.scss'

const cx = classNames.bind(styles)

declare type IconPosition = 'left' | 'right'

interface IProps {
  label?: string,
  children?: string,
  styleType?: string,
  iconPosition?: IconPosition,
  iconName?: string,
  onClick?: (ev: any) => any,
  round?: boolean,
  size?: string,
  fluid?: boolean,
  disabled?: boolean,
}

const ButtonWithIcon: React.SFC<IProps> = ({
  children,
  label = children,
  iconName,
  onClick,
  iconPosition = 'left',
  ...restProps
}) => (
  <Button
    {...restProps}
    onClick={onClick}
  >
    <div
      className={cx(
      'root',
       iconPosition,
      )}
    >
      <Icon name={iconName}/>
      {label && (<span className={styles.label}>{label}</span>)}
    </div>
  </Button>
)

export default ButtonWithIcon
